var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSidebarPracticeAi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7139 0H1.2853C0.969224 0 0.713867 0.255357 0.713867 0.571429V15.4286C0.713867 15.7446 0.969224 16 1.2853 16H12.7139C13.0299 16 13.2853 15.7446 13.2853 15.4286V0.571429C13.2853 0.255357 13.0299 0 12.7139 0ZM8.07101 1.28571H9.7853V5.03393L8.95494 4.42857L8.07101 5.06071V1.28571ZM11.9996 14.7143H1.99958V1.28571H6.99958V6.5875C6.99958 6.64643 7.01744 6.70536 7.05315 6.75357C7.07483 6.78422 7.10237 6.81026 7.13418 6.83019C7.16599 6.85013 7.20144 6.86355 7.23847 6.8697C7.27551 6.87584 7.31339 6.87458 7.34993 6.86599C7.38648 6.8574 7.42095 6.84165 7.45137 6.81964L8.9478 5.75L10.4014 6.81071C10.4496 6.84643 10.5085 6.86607 10.5692 6.86607C10.7264 6.86607 10.8549 6.7375 10.8549 6.58036V1.28571H11.9978V14.7143H11.9996Z",
    fill: "black",
    fillOpacity: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarPracticeAi);
export default __webpack_public_path__ + "static/media/sidebar-practice-ai.cfc64d49d365ad9d1ca1248dae52ce66.svg";
export { ForwardRef as ReactComponent };